import React from 'react'
import styled from 'styled-components'
import NYSLeft from "~/public/static/images/png/fetcher/NYSLeft.png"
import NYSRight from "~/public/static/images/png/fetcher/NYSRight.png"

const BackgroundImageLayerOne = styled.div`
  display: flex;
  height: 100%;
  flex-grow: 1;
  background-image: url(${NYSLeft});
  background-repeat: no-repeat;
`

const BackgroundImageLayerTwo = styled.div`
  display: flex;
  height: 100%;
  flex-grow: 1;
  background-image: url(${NYSRight});
  background-repeat: no-repeat;
  background-position: 100% 110%;
`
const NYSBackgroundLogos = ({ children }) => {
  return (
    <BackgroundImageLayerOne>
      <BackgroundImageLayerTwo>
        { children }
      </BackgroundImageLayerTwo>
    </BackgroundImageLayerOne>
  )
}

export default NYSBackgroundLogos
